import React from 'react';
import SubscriptionsCardContextProvider, {
  CanManageType,
} from './SubscriptionsCardContext';
import Content from './Content';

export type SubscriptionsCardProps = {
  userId?: string;
  redirectToMain?: () => Promise<void>;
  isMlsCovered?: boolean;
  isBoardCovered?: boolean;
  canManageSubscription: CanManageType;
  useLiveConciergePlus?: boolean;
  hasValidStripeMlsProductId: boolean; // Checking whether the mlsProductId is a valid Stripe ID.
  conciergeEnabled?: boolean;
};

const SubscriptionsCard: React.FC<SubscriptionsCardProps> = ({
  userId,
  redirectToMain,
  isMlsCovered,
  isBoardCovered,
  canManageSubscription,
  useLiveConciergePlus,
  hasValidStripeMlsProductId,
  conciergeEnabled,
}) => {
  const answeringSubscriptionLevel = userId ? 'user' : 'org';
  return (
    <SubscriptionsCardContextProvider
      answeringSubscriptionLevel={answeringSubscriptionLevel}
      userId={userId}
      redirectToMain={redirectToMain}
      canManageSubscription={canManageSubscription}
    >
      <Content
        answeringSubscriptionLevel={answeringSubscriptionLevel}
        isMlsCovered={isMlsCovered}
        isBoardCovered={isBoardCovered}
        useLiveConciergePlus={useLiveConciergePlus}
        hasValidStripeMlsProductId={hasValidStripeMlsProductId}
        conciergeEnabled={conciergeEnabled}
      />
    </SubscriptionsCardContextProvider>
  );
};

export default SubscriptionsCard;
